// extracted by mini-css-extract-plugin
export default {"div__1":"CreateAcc_div__1__r4GgH","div__2":"CreateAcc_div__2__K37FW","input__1":"CreateAcc_input__1__NXgFb","button":"CreateAcc_button__ieQKw","div__3":"CreateAcc_div__3__jIbjN"};